import LayoutActividad from "../../../components/LayoutActividad";
import Castellano1 from "../../../images/modulo14/u8castellano1.png";
import Castellano2 from "../../../images/modulo14/u8castellano2.png";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

const Actividad4 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[5];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[6].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[6].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[4].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[4].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-4">
            <img
              src={Castellano1}
              className="bg-white img-fluid rounded"
              alt="Conquitadores"
            />
          </div>
          <div className="col-md-8 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>La llegada del castellano al Perú</strong>
            </h4>
            <p className="mt-1">
              Al llegar los conquistadores españoles a nuestro país en el{" "}
              <strong>siglo XVI</strong>, encontraron una población muy diversa:
              distintas costumbres, distintas creencias, distintas lenguas.
            </p>
          </div>

          <div className="col-md-8 p-md-3 p-0">
            <p>
              Los incas habían impuesto la variedad de quechua que ellos
              hablaban como la{" "}
              <strong>“lengua general”</strong> que debía servir para que todos
              se entiendan.
            </p>
            <p>
              Poco a poco, los españoles
              <strong>impusieron el castellano</strong> {" "}
              en el territorio conquistado, pero también{" "}
              <strong>aprendieron quechua</strong>, sobre todo para transmitir
              la religión católica. Algunas palabras del quechua se hicieron
              parte del castellano peruano desde esta época hasta hoy.
            </p>
          </div>
          <div className="col-md-4">
            <img
              src={Castellano2}
              className="bg-white img-fluid rounded"
              alt="Conquistadores"
            />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida al niño o a la niña que lea el texto titulado La
            llegada del castellano al Perú. Pida que resuman
            las ideas más importantes señaladas en el texto. Por ejemplo:
            <ul>
              <li>
                <i>
                  “Cuando los españoles llegan al Perú, traen el castellano.
                  Aquí se encontraron con el quechua, que era la lengua impuesta
                  por los incas. Al castellano se incorporaron algunas palabras
                  en quechua que se mantienen hasta hoy”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
